// src/components/ui/InviteClientModal.jsx
import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Stack } from "@mui/material";
import ButtonComponent from "./ButtonComponent";

export default function InviteClientModal({
  open,
  onClose,
  onSend,           // (payload) => void
  isSending = false,
  client            // {id, fullName, email, phone}
}) {
  const [channel, setChannel] = React.useState("email");
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    if (!open) { setChannel("email"); setMessage(""); }
  }, [open]);

  const handleSend = () => {
    onSend?.({
      clientId: client?.id,
      channel,
      message: message || undefined
    });
  };

  return (
    <Dialog open={open} onClose={isSending ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Invite {client?.fullName || "Client"} to Client Portal</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            select
            label="Channel"
            fullWidth
            value={channel}
            onChange={(e) => setChannel(e.target.value)}
          >
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="sms">SMS</MenuItem>
          </TextField>

          <TextField
            label="Optional message"
            fullWidth
            multiline
            minRows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="We'll include the secure sign-in link automatically."
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <ButtonComponent label="Cancel" type="secondary" onClick={onClose} disabled={isSending} />
        <ButtonComponent label="Send Invite" type="primary" onClick={handleSend} isLoading={isSending} />
      </DialogActions>
    </Dialog>
  );
}